"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../Button"));
var _iconsReact = require("../../icons-react");
var _excluded = ["headRenderer", "contentRenderer"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Dropdown = /*#__PURE__*/function (_React$PureComponent) {
  function Dropdown(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Dropdown);
    _this = _callSuper(this, Dropdown, [props]);
    _this.state = {
      isOpen: props.open,
      isOpenProp: props.open
    };
    _this.el = /*#__PURE__*/_react["default"].createRef();
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleOpen = _this.handleOpen.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Dropdown, _React$PureComponent);
  return (0, _createClass2["default"])(Dropdown, [{
    key: "handleBlur",
    value: function handleBlur(_ref) {
      var relatedTarget = _ref.relatedTarget;
      var onToggle = this.props.onToggle;
      var isOpen = this.state.isOpen;
      if (isOpen && !this.el.current.contains(relatedTarget)) {
        this.setState({
          isOpen: false
        }, onToggle(false));
      }
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var onToggle = this.props.onToggle;
      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      }, onToggle(true));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        headRenderer = _this$props.headRenderer,
        contentRenderer = _this$props.contentRenderer,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement(StyledDropdown, (0, _extends2["default"])({}, props, {
        ref: this.el,
        onBlur: this.handleBlur
      }), /*#__PURE__*/_react["default"].createElement(StyledButton, {
        functional: true,
        onClick: this.handleOpen
      }, headRenderer, contentRenderer && /*#__PURE__*/_react["default"].createElement(StyledDropdownIcon, {
        open: isOpen
      })), contentRenderer && /*#__PURE__*/_react["default"].createElement(StyledContent, {
        hidden: !isOpen
      }, contentRenderer));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref2, _ref3) {
      var isOpen = _ref2.open;
      var isOpenProp = _ref3.isOpenProp;
      if (isOpen !== isOpenProp) {
        return {
          isOpenProp: isOpen,
          isOpen: isOpen
        };
      }
      return null;
    }
  }]);
}(_react["default"].PureComponent);
Dropdown.propTypes = {
  className: _propTypes["default"].string,
  headRenderer: _propTypes["default"].node.isRequired,
  contentRenderer: _propTypes["default"].node,
  onToggle: _propTypes["default"].func,
  open: _propTypes["default"].bool
};
Dropdown.defaultProps = {
  className: '',
  contentRenderer: null,
  onToggle: Function.prototype,
  open: false
};
var StyledDropdown = _styledComponents["default"].button.withConfig({
  displayName: "Dropdown__StyledDropdown",
  componentId: "sc-14sz1ca-0"
})(["cursor:pointer;position:relative;"]);
var StyledDropdownIcon = (0, _styledComponents["default"])(_iconsReact.Dropdown).withConfig({
  displayName: "Dropdown__StyledDropdownIcon",
  componentId: "sc-14sz1ca-1"
})(["width:9px;height:5px;margin:3px 0 0 5px;path{fill:#000;}", ""], function (props) {
  return props.open && "\n    transform: rotate(180deg);\n  ";
});
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Dropdown__StyledButton",
  componentId: "sc-14sz1ca-2"
})(["width:100%;height:100%;display:flex;cursor:pointer;align-items:center;"]);
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "Dropdown__StyledContent",
  componentId: "sc-14sz1ca-3"
})(["left:50%;z-index:2;display:flex;padding:10px;margin-top:10px;border-radius:4px;position:absolute;background-color:#fff;transform:translateX(-50%);box-shadow:0 2px 10px 0 rgba(0,0,0,0.1);::before{border-bottom:7px solid #fff;border-left:8px solid transparent;border-right:8px solid transparent;content:'';height:0;left:50%;margin-left:-8px;position:absolute;top:-6px;width:0;}", ""], function (props) {
  return props.hidden && "\n    display: none;\n  ";
});
Dropdown.StyledButton = StyledButton;
Dropdown.StyledDropdownIcon = StyledDropdownIcon;
Dropdown.StyledContent = StyledContent;
var _default = exports["default"] = Dropdown;